import React from 'react'
import BulkActions from "../../../user-manager/components/datas/BulkActions"

function RolesFunctionHead(props) {
    const {selectAll, arrSelected, onCheckALl} = props

    const _handleChangeChecked = (e) => {
        const {checked} = e.target

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    return <thead className="TableHead">
    <tr>
        <th className="bulkActions">
            <BulkActions selectAll={selectAll} arrSelected={arrSelected} onChange={_handleChangeChecked}/>
        </th>
        <th className="colItem">Mã chức năng</th>
        <th className="colItem">Tên chức năng</th>
    </tr>
    </thead>
}

export default RolesFunctionHead
